import { ModalId } from '@heidi/schema/ml-scribe';
import { atom } from 'jotai';

export const ADAPTIVE_LEARNING_OPTIN_POPOVER_MODAL_ID =
  ModalId.T4_CUSTOM_AUDIENCE_ADAPTIVE_LEARNING_OPTIN_POPOVER;

/**
 * Whether the adaptive-learning opt-in popover is eligible to enqueue right now.
 * Written by {@link useAdaptiveLearningPopover} while mounted on the session
 * page: `true` only when an `opt_in_ask` note-suggestions frame has arrived for
 * the current session and the user has not yet acted on the card this session.
 * The launch-modal queue reads this so the card is queued (and coordinated
 * against other bottom-left launch surfaces such as the V2 invite) only when it
 * is genuinely due — and never blocks the queue elsewhere.
 *
 * In-memory only: it tracks live eligibility, not a persisted preference.
 * Persistence / frequency ride entirely on the backend's decision to emit an
 * `opt_in_ask` frame (seen-modal view counts), never on `seen_modals` gating
 * here.
 */
export const adaptiveLearningPopoverEligibleAtom = atom<boolean>(false);

/**
 * Keeps the inline `opt_in_ask` preview visible after "Apply edits & turn on"
 * closes the card: set while the graduate mutation is in flight and until the
 * refetched (applied) note replaces the preview. Without it the preview is
 * gated on the card being the current queued modal, and clicking the card
 * would drop the decorations before the applied note arrives.
 */
export const adaptiveLearningPreviewHoldAtom = atom<boolean>(false);
